// Generated by CoffeeScript 1.12.6
(function() {
  'use strict';
  angular.module('app.jobApplicationHistory', [
    'pascalprecht.translate',
    'angularFileUpload',
    'angular.filter',
    'ngSlider',
    'ngCookies',
    'ngAnimate',
    'ngSanitize',
    'angularSpinner',
    'angular-clipboard',
    'ui.nested.combobox',
  ])
  .controller('jobApplicationHistoryCtrl', [
    '$http',
    '$log',
    '$location',
    '$scope',
    'currentLawyer',
    '$modal',
    '$window',
    '$translate',
    '$cookies',
    'logger',
    '$filter',
    'usSpinnerService',
    'jobApplicationEmailID',
    'sharedProperties',
    'lawyerAndAdminID',
    function($http, $log, $location, $scope, currentLawyer, $modal, $window, $translate, $cookies, logger, $filter, usSpinnerService, jobApplicationEmailID, sharedProperties, lawyerAndAdminID) {
      sharedProperties.verifyUser(_.range(11,18));
      $http.post('/api/fetch-current-user', {
        'contentType': 'application/json'
      }).then(function({data, status, headers, config}) {
        $scope.user = data;
        lawyerAndAdminID.setModel('user', $scope.user.userType);
      },function(data) {
        $log.info('error');
      });
      $scope.emailHistoryList = [];
      $scope.numPerPageOpt = [10, 20, 50];
      $scope.numPerPage = $scope.numPerPageOpt[2];
      $scope.currentPage = 1;
      $scope.currentPageItems = [];
      $scope.row = '';
      $scope.rorder = '';
      $scope.totalEmailHistoryList = 0;

      // Start the spinning loader
      usSpinnerService.spin('lexstep-spinner');
      // Fetch the Application History Records
      $http.post('/api/fetch-job-application-history')
      .then(function ({data, status, headers, config}) {
        $scope.emailHistoryList = data;
        $scope.totalEmailHistoryList = $scope.emailHistoryList.length;

        // Format UI for fetched records to be used as for the
        // pagination
        $scope.select(1);
        // Stop the spinning loader to show that the application
        // records has been loaded
        usSpinnerService.stop('lexstep-spinner');
      }).catch(function({data, status, headers, config}) {
        if (status === 440) {
          $location.url('/signin');
        }
        // Stop the spinning loader to show that the request
        // is completed
        usSpinnerService.stop('lexstep-spinner');
      });

      $scope.logOut = function() {
        sharedProperties.logOut();
      };

      $scope.select = function(page) {
        var end, start;
        start = (page - 1) * $scope.numPerPage;
        end = start + $scope.numPerPage;
        return $scope.currentPageItems = $scope.emailHistoryList.slice(start, end);
      };
      $scope.onNumPerPageChange = function() {
        $scope.select(1);
        return $scope.currentPage = 1;
      };
      $scope.onOrderChange = function() {
        $scope.select(1);
        return $scope.currentPage = 1;
      };
      $scope.order = function(rowName, rorder) {
        if (rorder === "desc") {
          rowName = '-' + rowName;
        }
        if ($scope.row === rowName && $scope.rorder === rorder) {
          return;
        }
        $scope.row = rowName;
        $scope.emailHistoryList = $filter('orderBy')($scope.emailHistoryList, rowName);
        return $scope.onOrderChange();
      };
      $scope.viewJobApplicationEmail = function(emailID) {
        $log.info(emailID);
        jobApplicationEmailID.setModel('emailID', emailID);
        $log.info("Again");
        $log.info(jobApplicationEmailID.getModel('emailID'));
        $location.url('/admin/email-history-view');
      };
      $scope.logOut = function() {
        sharedProperties.logOut();
      };
      $scope.backButton = function() {
        $http.post('/api/show-inhouse-firms').then(function({data, status, headers, config}) {
          $location.url('/admin/admin-listings');
        },function(data) {
          $log.info('error');
        });
      };

      return $scope.navigateToEmailListing = function() {
        $location.url('/admin/email-listing');
      };
    }
  ]);

}).call(this);



// WEBPACK FOOTER //
// ./scripts/job-application-history/jobApplicationHistoryCtrl.js